/**
 * Created by Rakesh Peela
 * Date: 26-Nov-2019
 * Time: 4:15 PM
 */

import generateShortID from "../../../utils";

export const POSITION_ENUM = {
    TOP: "TOP",
    BOTTOM: "BOTTOM",
    LEFT: "LEFT",
    RIGHT: "RIGHT"
};

export const MESSAGE_TOOLTIP_LAYOUT_TYPES = {
    ACTION_BUTTONS: "action_buttons",
    DEFAULT: "default",
    IMAGE_TEXT_BUTTONS: "image_text_buttons",
    INLINE_WITH_DOT: "inline_with_dot",
    TOOLTIP_WITH_COACHMARK: "default",
    TEXT_WITH_FIXED_BUTTONS: "text_with_fixed_buttons",
};

export const MESSAGE_NUDGE_LAYOUT_TYPES = {
    DEFAULT: "default"
};

export const MESSAGE_COACHMARK_LAYOUT_TYPES = {
    DEFAULT: "default",
};

export const INAPP_LAYOUT_TYPES = {
    HEADER: "header",
    FOOTER: "footer",
    POPOUT_MODAL: "popout_modal",
    CLASSIC_MODAL: "classic_modal",
    FULL_SCREEN_MODAL: "full_screen_modal",
    CUSTOM_HTML: "custom"
};

export const ACTIONS_ENUM = {
    "DISMISS": "dismiss",
    "REDIRECT": "redirect",
    "CANCEL": "cancel"
};

const ANIMATION_CONFIG = {
    "duration": 400,
    "enabled": true,
    "type": "cycle"                 /* "cycle" || "bounce" */
};

const CONSTANT_CONFIGS = {
    "language_attribute": "",
    "localization_enabled": false,
};

const CONTAINER_CONFIG = {
    "bg_color": "#FFFFFF",
    "opacity": 1,
    "position": POSITION_ENUM.BOTTOM,
    "border": {
        "color": "#045343",
        "width": 0
    },
    "button_position": "right",     /* "center" || "left" || "right" */
    "corners": {
        "enabled": true,
        "width": 8
    },
    "dimmed_background": false,
    "dim_background": false,
    "dim_background_opacity": 0.6,
    "dim_background_color": "#5c5c5c",
    "dismiss_outside_touch": false,
    "layout_type": "default",
    "view_id": "",
    "animation": {
        ...ANIMATION_CONFIG
    }
};

const PADDING_CONFIG = {
    "padding_config": {
        "bottom": 0,
        "left": 0,
        "right": 0,
        "top": 0
    }
};

const MARGIN_CONFIG = {
    "margin_config": {
        "bottom": 8,
        "left": 8,
        "right": 8,
        "top": 8
    }
};

const TEXT_CONFIG = {
    "color": "#242424",
    "font_family": "sans-serif",    /* "sans-serif" || "cursive" || "monospace" */
    ...MARGIN_CONFIG,
    ...PADDING_CONFIG,
    "size": 16,                     /* min: 12, max: 24 */
    "style": "normal",              /* "normal" || "bold" || "italic" */
    "text": "Text",
    "localized_messages": {}
};

const ACTION_BUTTON_CONFIG = {
    "color": "#3d5779",
    "visibility": 1,
    "text_config": {
        "text": "Bookmarks",
        "size": 20,
        "style": "normal",
        "color": "#F1F1F1",
        "font_family": "sans-serif"
    },
    "image": "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",
    "description_config": {
        "text": "Add this site to my bookmarks",
        "size": 14,
        "style": "normal",
        "color": "#F1F1F1",
        "font_family": "sans-serif"
    },
    "action_config": {"action": "dismiss", "activity": "", "is_deep_link": false},
    __id: generateShortID()
};

const BUTTON_CONFIG = {
    "action_config": {
        "action": "dismiss",        /* "dismiss" || "redirect" || "cancel" */
        "activity": "",
        "is_deep_link": false
    },
    "borders": {
        "radius": 0,
        "stroke_color": "#000000",
        "stroke_width": 1
    },
    "color": "#27a4f2",
    "id": "",
    ...MARGIN_CONFIG,
    ...PADDING_CONFIG,
    "text_config": {
        ...TEXT_CONFIG
    },
    "visibility": 1
};

const DUMMY_INLINE_UI_CONFIG = {
    "name": "",
    "activity": "",
    "delay": 1000,
    "display_type": "inline",
    "type": "IN_LINE",
    "title_config": {
        ...TEXT_CONFIG,
        style: "bold",
        size: 18,
        "text": "Title",
        __id: "uCwdrrqvb-7Dc5eQYjE"
    },
    "text_config": {
        ...TEXT_CONFIG,
        "text": "Description",
        __id: "xbOMVSFiO-WF5QGkh0D"
    },
    "buttons_config": [
        {
            ...BUTTON_CONFIG,
            __id: "ctmpy1XYy-Nr4JPARXF",
        },
        {
            ...BUTTON_CONFIG,
            __id: "VYvJfbeq1-7Dc5eQYjE"
        }
    ],
    ...CONTAINER_CONFIG,
    ...CONSTANT_CONFIGS
};

const DUMMY_CUSTOM_HTML_CONFIG = {
    "name": "",
    "layout": "html_layout",
    "delay": 1000,
    "type": "IN_APP",
    "window_attributes": {
        "position": "CENTER",
        "dimmed_background": false,
        "dismiss_outside_touch": false,
        "has_animation": true,
        "animation_duration": 400
    },
    "html_config": {
        "width": 100,
        "height": 100,
        "data": "",
        "url": ""
    },
    ...CONTAINER_CONFIG,
    ...CONSTANT_CONFIGS,
};

const DUMMY_INAPP_CONFIG = {
    "name": "",
    "bg_color": "#FFFFFF",
    "bg_image": "",
    "image_size": "cover",
    "layout": "html_layout",
    "delay": 1000,
    "type": "IN_APP",
    "orientation": "Portrait",
    "image": "https://images.unsplash.com/photo-1577578306649-09e937512e28?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=400&q=50",
    "border_radius": 2,
    "only_image": false,
    "touch_redirect_url": "",
    "title_config": {
        ...TEXT_CONFIG,
        style: "bold",
        size: 18,
        "text": "Title",
        __id: "uCwdrrqvb-7Dc5eQYjE"
    },
    "text_config": {
        ...TEXT_CONFIG,
        "text": "Description",
        __id: "xbOMVSFiO-WF5QGkh0D"
    },
    "buttons_config": [
        {
            ...BUTTON_CONFIG,
            "text_config": {
                ...TEXT_CONFIG,
                "text": "Ok"
            },
            __id: "ctmpy1XYy-Nr4JPARXF",
        },
        {
            ...BUTTON_CONFIG,
            "text_config": {
                ...TEXT_CONFIG,
                "text": "Cancel"
            },
            __id: "VYvJfbeq1-7Dc5eQYjE"
        }
    ],
    "window_attributes": {
        "position": "CENTER",
        "dimmed_background": true,
        "dismiss_outside_touch": true,
        "has_animation": true,
        "animation_duration": 400
    },
    "html_config": {
        "width": 100,
        "height": 100,
        "data": "",
        "url": ""
    },
};

export {
    ANIMATION_CONFIG,
    CONSTANT_CONFIGS,
    CONTAINER_CONFIG,
    PADDING_CONFIG,
    TEXT_CONFIG,
    MARGIN_CONFIG,
    BUTTON_CONFIG,
    ACTION_BUTTON_CONFIG,
    DUMMY_INLINE_UI_CONFIG,
    DUMMY_INAPP_CONFIG,
    DUMMY_CUSTOM_HTML_CONFIG
};